module.exports = __webpack_public_path__ + "static/media/img4-200-200.104b80eb.png";